import {
  Button,
  Grid,
  Box,
  Divider,
  List,
  ListSubheader,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Dialog,
  Slide,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Link, useHistory } from "react-router-dom";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Fragment, useState, useEffect, forwardRef } from "react";
import add_comma from "../lib/add_comma";
import send_webview_data from "../lib/send_webview_data";
import moment from "moment";
import axios from "axios";
import { configState } from "../lib/State";
import BottomMenu from "./BottomMenu";
import Swal from "sweetalert2";
import Login from "./Login";
import get_cid from "../lib/get_cid";
import get_center from "../lib/get_center";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const listTheme = createTheme({
  components: {
    MuiListSubheader: {
      styleOverrides: {
        root: {
          lineHeight: "20px",
          color: "black",
          fontWeight: "bold",
          fontSize: "16px",
          display: "flex",
          alignItems: "center",
          margin: "5px 0 10px 0",
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          paddingTop: 0,
          fontSize: "14px",
          color: "rgba(0, 0, 0, 0.6)",
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          color: "black",
        },
      },
    },
  },
});

const typoTheme = createTheme({
  typography: {
    fontFamily: "BebasNeue",
  },
});

const CustomListItem = (props) => {
  const onBuyClick = props.onBuyClick;
  let {
    pid,
    gubun,
    amount,
    title,
    type,
    term,
    pt_count,
    origin_price,
    discount_rate,
    is_season,
  } = props.item;
  let amount_c = add_comma(amount);
  let amount_o = add_comma(origin_price);
  if (type === "month") type = "개월";
  if (type === "day") type = "일";

  const onAlertTest = () => {
    send_webview_data({
      id: "alert",
      msg: "TEST 메시지",
    });
  };

  return (
    <>
      <ListItem
        onClick={() =>
          onBuyClick({
            pid: pid,
            gubun: gubun,
            amount: amount,
            title: title,
            type: type,
            term: term,
            pt_count: pt_count,
            origin_price: origin_price,
            discount_rate: discount_rate,
            is_season,
          })
        }
        sx={{
          paddingTop: "8px",
        }}
      >
        <ListItemIcon>
          {is_season === "Y" ? (
            <img src={`/img/class_season.png`} height="84px" width="84px" />
          ) : (
            <img
              src={`/img/${gubun.toLowerCase()}_${("00" + pt_count).slice(
                -2,
              )}.jpg`}
              height="84px"
              width="84px"
              onError={(e) => {
                e.target.parentElement.style.display = "none";
              }}
            />
          )}
        </ListItemIcon>
        <ListItemText
          sx={{
            marginLeft: "15px",
          }}
          primary={title}
          secondary={
            <Fragment>
              {/* {"유효기간:" + term + type + ""}
              <br></br> */}
              {discount_rate === 0 ||
              origin_price === 0 ||
              is_season === "Y" ? (
                <Box sx={{ color: "#464646" }}>{amount_c}원</Box>
              ) : (
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        fontSize: "12px",
                        marginTop: "2px",
                        marginRight: 0.5,
                        color: "red",
                      }}
                    >
                      {discount_rate}%할인
                    </Box>
                    <Box
                      style={{
                        textDecoration: "line-through",
                        color: "gray",
                        fontSize: "13px",
                        marginTop: "2px",
                      }}
                    >
                      {amount_o}
                    </Box>
                  </Box>
                  <Box sx={{ color: "#464646", marginTop: "-4px" }}>
                    {amount_c}원
                  </Box>
                </Box>
              )}
            </Fragment>
          }
        />
        {/* <Button variant="contained" onClick={onAlertTest}>
          Test
        </Button> */}
        {/* <Button
          variant="contained"
          sx={{
            background: "#0092a2",
            "&.MuiButton-root:hover": { background: "#0092a2" },
          }}
          onClick={() =>
            onBuyClick({
              pid: pid,
              gubun: gubun,
              amount: amount,
              title: title,
              type: type,
              term: term,
              pt_count: pt_count,
            })
          }
        >
          구매하기
        </Button> */}
        <IconButton>
          <img
            src="/img/back_button_black.png"
            style={{ transform: "scaleX(-1)" }}
          />
        </IconButton>
      </ListItem>
      <Divider />
    </>
  );
};

const BuyLoggedOut = () => {
  const cid = get_cid();
  const center = get_center(cid);
  const [rows, setRows] = useState([]);
  const [openLogin, setOpenLogin] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);

  const gohyeonRows = rows.filter(
    (el) => el.pid !== "PDR10000038" && el.pid !== "PDR10000040",
  );
  const jeongguanRows = rows.filter(
    (el) => el.pid !== "PDR00000086" && el.pid !== "DOC00000009",
  );

  const get_product = async () => {
    let result = await axios.post(configState.api + "/gympass/get_product", {
      cid: center.product_cid,
    });
    setRows(result.data.rows);
  };

  useEffect(() => {
    get_product();
  }, []);

  const onBuyClick = async () => {
    Swal.fire({
      title: "로그인 하시겠습니까?",
      showConfirmButton: true,
      showCancelButton: true,
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          setOpenLogin(true);
        }
      })
      .catch((e) => Swal.fire(e));
  };

  const clickCloseLogin = () => {
    setOpenLogin(false);
    setOpenAlert(false); // 알럿창 닫기
  };

  return (
    <Grid container height="100%">
      <Dialog
        fullScreen
        open={openLogin}
        TransitionComponent={Transition}
        onClose={clickCloseLogin}
      >
        <Box
          sx={{
            width: "90%",
            textAlign: "left",
            padding: "30px 0 10px 10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <img src="/img/back_button_black.png" onClick={clickCloseLogin} />
          <Box
            sx={{
              margin: "16px 0 0 10px",
              fontSize: "25px",
              fontWeight: "bold",
            }}
          >
            로그인
          </Box>
        </Box>
        <Login onCloseLogin={clickCloseLogin}></Login>
      </Dialog>
      <Box
        sx={{
          width: "100%",
          height: "50px",
          background: "black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img src={center.logo} height="35px" />
      </Box>
      <Box
        style={{
          // position: "fixed",
          // position: "absolute",
          top: 0,
          width: "100%",
          height: "260px",
          overflow: "hidden",
          zIndex: 10,
          position: "relative",
        }}
      >
        <img src="/img/buy_header_noword.png" style={{ width: "100%" }} />
        <ThemeProvider theme={typoTheme}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              // fontWeight: 'bold'
            }}
          >
            <Box
              sx={{
                fontSize: "46px",
                fontFamily: "BebasNeue",
                color: "white",
              }}
            >
              BUY COUPON
            </Box>
            {/* <Box
              sx={{
                fontSize: "18px",
                color: "white",
                fontWeight: "bold",
                textAlign: "center",
                marginTop: "-6px",
              }}
            >
              쿠폰구매
            </Box> */}
          </Box>
        </ThemeProvider>
      </Box>

      <Grid container direction="column" width="100%">
        <Divider />
        {center.pass_coupon_sale ? (
          <>
            <ThemeProvider theme={listTheme}>
              {rows.filter((el) => el.gubun === "PASS").length > 0 && (
                <Link
                  to="/buy_description"
                  underline="none"
                  style={{ textDecoration: "none" }}
                >
                  <ListSubheader>
                    패스 쿠폰
                    <HelpOutlineIcon fontSize="small" color="action" />
                  </ListSubheader>
                </Link>
              )}
              {rows.map((item, index) => {
                let { gubun } = item;
                if (gubun === "PASS") {
                  return (
                    <CustomListItem
                      onBuyClick={onBuyClick}
                      key={index}
                      item={item}
                    ></CustomListItem>
                  );
                }
              })}
            </ThemeProvider>
            <Divider width="100%" />
          </>
        ) : null}
        <List sx={{ zIndex: 0 }}>
          <ThemeProvider theme={listTheme}>
            <Link
              to="/buy_description"
              underline="none"
              style={{ textDecoration: "none" }}
            >
              <ListSubheader>
                클래스 쿠폰
                <HelpOutlineIcon fontSize="small" color="action" />
              </ListSubheader>
              {/* <ListItem>클래스 쿠폰은 수업 예약에 필요한 쿠폰입니다.</ListItem> */}
            </Link>
            {rows.map((item, index) => {
              let { gubun } = item;
              if (gubun === "CLASS") {
                return (
                  <CustomListItem
                    onBuyClick={onBuyClick}
                    key={index}
                    item={item}
                  ></CustomListItem>
                );
              }
            })}
          </ThemeProvider>
        </List>

        {center.pt_coupon_sale === true && (
          <List sx={{ zIndex: 0 }}>
            <ThemeProvider theme={listTheme}>
              <Link
                to="/buy_description"
                underline="none"
                style={{ textDecoration: "none" }}
              >
                <ListSubheader>
                  PT 쿠폰
                  <HelpOutlineIcon
                    fontSize="small"
                    color="action"
                    style={{ marginLeft: 3 }}
                  />
                </ListSubheader>
              </Link>

              {rows.filter((el) => el.gubun === "PT_MANAGER").length > 0 && (
                <>
                  <Box
                    sx={{
                      paddingLeft: "16px",
                    }}
                  >
                    점장 PT
                  </Box>
                  {rows.map((item, index) => {
                    let { gubun } = item;
                    if (gubun === "PT_MANAGER") {
                      return (
                        <CustomListItem
                          onBuyClick={onBuyClick}
                          key={index}
                          item={item}
                        ></CustomListItem>
                      );
                    }
                  })}
                </>
              )}

              {rows.filter((el) => el.gubun === "PT_TRAINER").length > 0 && (
                <>
                  <Box
                    sx={{
                      paddingLeft: "16px",
                      marginTop: "10px",
                    }}
                  >
                    트레이너 PT
                  </Box>
                  {rows.map((item, index) => {
                    let { gubun } = item;
                    if (gubun === "PT_TRAINER") {
                      return (
                        <CustomListItem
                          onBuyClick={onBuyClick}
                          key={index}
                          item={item}
                        ></CustomListItem>
                      );
                    }
                  })}
                </>
              )}
            </ThemeProvider>
          </List>
        )}

        <Box sx={{ height: "133px" }}></Box>
      </Grid>
      <BottomMenu sx={{ zIndex: 8 }}></BottomMenu>
    </Grid>
  );
};

export default BuyLoggedOut;
